"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateInventory = exports.useFetchLatestInventory = void 0;
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const inventoryAction_1 = require("./inventoryAction");
const AuthGuard_1 = require("../../components/tsComponents/AuthGuard");
const useFetchLatestInventory = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const fetchLatestInventoryLoading = (0, react_redux_1.useSelector)((state) => state["inventory/fetchLatestInventory"].loading);
    const fetchLatestInventoryError = (0, react_redux_1.useSelector)((state) => state["inventory/fetchLatestInventory"].error);
    const fetchLatestInventoryData = (0, react_redux_1.useSelector)((state) => state["inventory/fetchLatestInventory"].data);
    const fetchLatestInventoryHook = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        let isUserLogged = yield (0, AuthGuard_1.isLoggedIn)();
        if (!isUserLogged) {
            history("/auth/sign-in");
            return;
        }
        yield dispatch((0, inventoryAction_1.fetchLatestInventory)(payload));
    });
    return {
        fetchLatestInventoryLoading,
        fetchLatestInventoryError,
        fetchLatestInventoryData,
        fetchLatestInventoryHook
    };
};
exports.useFetchLatestInventory = useFetchLatestInventory;
const useUpdateInventory = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const updateInventoryLoading = (0, react_redux_1.useSelector)((state) => state["inventory/update"].loading);
    const updateInventoryError = (0, react_redux_1.useSelector)((state) => state["inventory/update"].error);
    const updateInventoryData = (0, react_redux_1.useSelector)((state) => state["inventory/update"].data);
    const updateInventory = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let isUserLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!isUserLogged) {
                history("/auth/sign-in");
                return;
            }
            const res = yield dispatch((0, inventoryAction_1.update)(payload));
            if (res.meta.requestStatus === "fulfilled") {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === "rejected") {
                throw new Error("Error updating inventory");
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        updateInventoryLoading,
        updateInventoryError,
        updateInventoryData,
        updateInventory
    };
};
exports.useUpdateInventory = useUpdateInventory;
